import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';

interface TextProps {
  bold?: boolean;
}

interface CellProps {
  whiteBg?: boolean;
  isHeader?: boolean;
  isFirstCell?: boolean;
  isCellFromLastRow?: boolean;
}

export const AdvantagesSectionCellElement = styled.td<CellProps>`
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  color: ${({ isHeader, isFirstCell }) => (isHeader || isFirstCell ? getColor('GRAY_50') : getColor('GRAY_70'))};
  background-color: ${({ whiteBg }) => (whiteBg ? getColor('BEIGE_5') : 'transparent')};
  border-bottom: ${({ isHeader }) => (isHeader ? '2px' : '1px')} solid ${getColor('GRAY_40')};
  padding: ${({ isHeader }) => (isHeader ? '24px 16px' : '16px 16px 32px 16px')};
  width: ${({ isFirstCell }) => (isFirstCell ? '185px' : 'auto')};
  font-weight: ${({ isHeader, isFirstCell }) => (isHeader || isFirstCell ? '600' : '400')};
  background-clip: padding-box; // https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o
  vertical-align: ${({ isHeader }) => (isHeader ? 'bottom' : 'top')};

  @media (max-width: ${TabletWidth}px) {
    padding: ${({ isHeader }) => (isHeader ? '0px 8px 8px 8px' : '12px 8px')};
    font-size: 14px;
    width: ${({ isFirstCell }) => (isFirstCell ? '100px' : 'auto')};
    border-bottom: ${({ isHeader, isCellFromLastRow }) =>
      isCellFromLastRow ? 'none' : `${isHeader ? '2px' : '1px'} solid ${getColor('GRAY_40')}`};
  }
`;
export const AdvantagesSectionLogoWrapper = styled.div`
  display: flex;
  align-self: center;
`;
export const AdvantagesSectionCirclesLogo = styled.img`
  margin-right: 4px;
`;
export const AdvantagesSectionCirclesLogoText = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: ${getColor('GRAY_70')};
`;

export const AdvantagesSectionCellText = styled.span<TextProps>`
  font-weight: ${({ bold }) => (bold ? '600' : 'inherit')};
`;
